export enum RecordingStatus {
    RECORDING = 'RECORDING',
    PROCESSING = 'PROCESSING',
    AVAILABLE = 'AVAILABLE',
    DELETED = 'DELETED',
    EXTERNAL = 'EXTERNAL'
}

export enum Permission {
    NOOVERRIDE = 'NOOVERRIDE', // Required for overrides.
    PUBLIC = 'PUBLIC',
    ROSTER = 'ROSTER',
    ADMINS = 'ADMINS'
}

export enum IngestMode {
    EXCLUDE = 'EXCLUDE',
    TRANSFER = 'TRANSFER',
    TRACK_ONLY = 'TRACK_ONLY'
}

export enum ArtifactTransferMode {
    COPY = 'COPY',
    MOVE = 'MOVE',
    IGNORE = 'IGNORE'
}

export enum ConfigIngestModes {
    EXCLUDE = 'EXCLUDE',
    TRACK = 'TRACK',
    COPY = 'COPY',
    MOVE = 'MOVE'
}

export type ArtifactType =
    | 'active_speaker'
    | 'audio_only'
    | 'audio_only_each_participant'
    | 'audio_transcript'
    | 'closed_caption'
    | 'composite'
    | 'gallery_view'
    | 'host_video'
    | 'shared_screen'
    | 'shared_screen_with_gallery_view'
    | 'shared_screen_with_speaker_view'
    | 'shared_screen_with_speaker_view(CC)'
    | 'timeline';

export type Artifact = {
    recordingId: string;
    contents: string;
    timeToLive: number;
    url: string;
    type: ArtifactType;
};

export type Artifacts = {
    active_speaker?: Artifact;
    closed_caption?: Artifact;
    composite?: Artifact;
    timeline?: Artifact;
    audio_only?: Artifact;
    gallery_view?: Artifact;
    shared_screen?: Artifact;
    shared_screen_with_gallery_view?: Artifact;
    shared_screen_with_speaker_view?: Artifact;
    'shared_screen_with_speaker_view(CC)'?: Artifact;
};

export type ResponseRecordingInformation = {
    schoolId: string;
    classId: string;
    sessionId: string;
    recordingId: string;
    name: string;
    status: RecordingStatus;
    permission?: Permission;
    when: string;
    duration?: number;
    artifacts?: Record<string, string>;
    size?: number;
    totalViews: number;
    lastViewed?: string;
};

export type ResponseArtifact = {
    artifacts: Artifact[];
};
